import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {green, marketingMobileCuttoff, white} from "@css/constants";
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {Button} from "@components/Button";

export const CallNowSectionContainer = styled('div')(css`
  background-color: ${green};
`)

export const CallNowSectionWrapper = styled('div')(css`
  display: flex;
  padding: 70px 16px;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`)

export const CallNowSectionContent = styled('div')(css`
  margin: 0 auto;
  width: 90%;
  max-width: 1000px;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
  }
`)

export const CallNowSectionColumn = styled('div')(css`
  width: 50%;
  float: left;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    float: none;
    text-align: center;
  }
`)

export const CallNowSectionNumberColumn = styled('div')<CallNowSectionTextProps>((props) => css`
  width: 50%;
  float: left;
  text-align: center;
  margin-top: 4px;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 12px;
    width: 100%;
    float: none;
    text-align: ${props.mobileTextLeft ? 'start' : 'center'};
  }
`)

export type CallNowSectionTextProps = {
  mobileTextLeft?: boolean
}

export const CallNowSectionText = styled('h1')<CallNowSectionTextProps>((props) => css`
  ${fontSize(32)};
  ${FontNormal(600)};
  color: ${white};
    
  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(20)};
    padding: 5px 0;
    text-align: ${props.mobileTextLeft ? 'start' : 'center'};
  }
`)

export const PhoneNumberWrapper = styled('span')(css`
  ${fontSize(18)};
  ${FontNormal(500)};
  width: 85%;
  color: ${white};
  text-decoration: underline;
  cursor: pointer;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
  }
`);

export const CallSpan = styled('span')(css`
  ${fontSize(20)};
  ${FontNormal(600)};
  color: ${white};
  text-decoration: none;
  cursor: pointer;
`);

export const HoursSpan = styled('span')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  color: ${white};
`);

export const StyledDiv = styled('div')(css`
  padding-bottom: 8px;
`);

export type CallNowSectionButtonWrapperProps = {
  buttonFullWidth?: boolean
}

export const CallNowSectionButtonWrapper = styled('div')<CallNowSectionButtonWrapperProps>((props) => css`
  margin-top: 20px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    margin-bottom: 20px;
    ${props.buttonFullWidth ? `width: 100%;` : ''}
  }
`)
